// src/i18n/locales/en/subscribe.ts
// Translation keys for the /subscribe page and subscription-related toasts.

const subscribe = {
  // Page titles
  title: 'Choose your plan',
  subtitle: 'Start your personalized nutrition journey today.',
  returningTitle: 'Reactivate your subscription',
  returningSubtitle: 'Pick up where you left off — your data is still here.',

  // Billing toggle
  billing: {
    monthly: 'Monthly',
    yearly: 'Yearly',
    saveLabel: 'Save {{percent}}%',
  },

  // Plan cards
  plans: {
    basic: {
      name: 'BASIC',
      price: 'CHF 14.90',
      yearlyPrice: 'CHF 11.92',
      period: '/ month',
      yearlyNote: 'CHF 143.00 billed yearly',
      cta: 'Get BASIC',
      features: [
        '1× complete 30-day plan',
        'Simple meal descriptions',
        'Calories & ingredients per day',
        'Considers allergies & preferences',
      ],
      missing: [
        'Plan modifications',
        'Detailed recipes',
        'Shopping list included',
        'PDF export',
        'NutriBot chat',
        'Daily coaching emails',
      ],
    },
    vip: {
      name: 'VIP',
      badge: 'Most popular',
      price: 'CHF 29.90',
      yearlyPrice: 'CHF 23.92',
      period: '/ month',
      yearlyNote: 'CHF 287.00 billed yearly',
      cta: 'Get VIP',
      features: [
        'Unlimited 30-day plans',
        'Change & adjust at any time',
        'Detailed step-by-step recipes',
        'Complete shopping list & recipe list',
        'PDF export for all plans',
        'Dashboard with progress tracking',
        'Daily motivational emails',
        '24/7 NutriBot chat assistant',
      ],
    },
  },

  // Post-checkout verification states
  verification: {
    checking: 'Verifying your payment...',
    success: 'Payment confirmed! Redirecting you...',
    pending: 'Your payment is confirmed, but activation is taking a moment.',
    pendingHint: 'Click below to check again or wait a few seconds.',
    failed: 'We could not verify your payment. If you were charged, please use the refresh button.',
    refreshButton: 'Check activation status',
    syncing: 'Checking...',
  },

  // Guarantee / trust strip
  guarantee: {
    money: '30-day money-back guarantee',
    cancel: 'Cancel anytime',
    secure: 'Secure payment via Stripe',
  },

  // Toasts and feedback
  cancelSuccess: 'Subscription cancelled. Access until {{date}}.',
  errors: {
    checkoutFailed: 'Failed to start checkout. Please try again.',
    portalFailed: 'Failed to open the payment portal. Please try again.',
    cancelFailed: 'Failed to cancel subscription. Please try again.',
    syncFailed: 'Could not verify subscription status. Please try again.',
  },

  // Promo code field on checkout page
  promo: {
    title: 'Have a Promo Code?',
    placeholder: 'Enter code (e.g. ANNA2025)',
    apply: 'Apply',
    applying: 'Checking...',
    remove: 'Remove',
    appliedLabel: '{{pct}}% discount',
    errors: {
      invalid: 'Invalid or inactive promo code.',
      expired: 'This code has expired.',
      notYet: 'This code is not active yet.',
      maxUses: 'This code has reached its maximum number of uses.',
      alreadyUsed: 'You have already used this code.',
      failed: 'Failed to validate code. Please try again.',
    },
  },
};

export default subscribe;